export default __webpack_public_path__ + "e19bddfcbc59113e94ca844e0396c34c.gif";